/**
 * Registro de MyBarceló.
 *
 * Vive aparte de mybarcelo-auth.js y de mybarcelo-forgot.js, y comparte con
 * este último las dos piezas de interfaz que expone mybarcelo-ui.js.
 *
 * Dos mecanismos de navegación conviven sin unificarse, igual que en la
 * recuperación de contraseña: MyBarceloModal._switchTab() gobierna las dos
 * pestañas de primer nivel (login y register), y el goTo() de aquí mueve las
 * sub-secciones register-*. Unificarlos es el refactor de mybarcelo-modal.js,
 * descartado por reescribir código probado a las puertas de un despliegue.
 */
(function () {
  'use strict';

  var CONFIG = window.myBarceloConfig || {};

  // Los mensajes vienen de PHP (wp_localize_script) para que WPML pueda
  // traducirlos: un literal aquí dentro se quedaría en inglés para siempre.
  var I18N = window.bexRegisterI18n || {};

  function t(clave, reserva) {
    return I18N[clave] || reserva;
  }

  var BexRegister = {

    modal: null,
    codigo: null,
    politica: null,
    temporizador: null,

    // Los datos del alta se guardan porque "Solicitar un nuevo código" repite
    // el INITIALIZE entero: el OTP del registro es de un solo uso.
    estado: {
      email: '',
      firstName: '',
      lastName: '',
      birthdate: '',
      password: '',
      identifier: ''
    },

    // En estas dos el diseño sustituye las pestañas por una flecha de volver.
    SIN_PESTANAS: ['register-code', 'register-done'],

    init: function () {
      this.modal = document.getElementById('mybarcelo-modal');
      if (!this.modal) return;
      if (!this.modal.querySelector('[data-section="register"]')) return;

      this.initPolitica();
      this.initFormulario();
      this.initComponenteCodigo();
    },

    /** Mueve las sub-secciones del registro y lleva el foco al primer campo. */
    goTo: function (name) {
      var secciones = this.modal.querySelectorAll('.mybarcelo-modal__section');

      secciones.forEach(function (s) {
        s.classList.toggle('d-none', s.dataset.section !== name);
      });

      var pestanas = this.modal.querySelector('.mybarcelo-modal__tabs');
      if (pestanas) {
        pestanas.classList.toggle('d-none', this.SIN_PESTANAS.indexOf(name) !== -1);
      }

      var activa = this.modal.querySelector('.mybarcelo-modal__section:not(.d-none)');
      if (!activa) return;

      var foco = activa.querySelector('input:not([type="hidden"]), button:not([disabled])');
      if (foco) foco.focus();
    },

    getRecaptchaToken: function (action) {
      // Se reutiliza el cargador diferido del flujo de recuperación para no
      // pedir el script de Google dos veces.
      if (window.BexForgotPassword && window.BexForgotPassword.getRecaptchaToken) {
        return window.BexForgotPassword.getRecaptchaToken(action);
      }
      return Promise.resolve('');
    },

    post: function (ruta, datos) {
      return fetch(CONFIG.restBase + '/mybarcelo/registration/' + ruta, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(datos)
      }).then(function (resp) {
        return resp.json();
      });
    },

    // --- Política de contraseña ---

    initPolitica: function () {
      var self = this;

      this.politica = window.BexMybUi.crearPoliticaContrasena({
        input: document.getElementById('mybarcelo-register-password'),
        lista: this.modal.querySelector('[data-register="policy"]'),
        ojo: this.modal.querySelector('[data-register="toggle-password"]'),
        alCambiar: function (delUsuario) {
          if (delUsuario) self.limpiarError('error');
          self.refrescarBotonAlta();
        }
      });
    },

    // --- Paso 2: el código ---

    initComponenteCodigo: function () {
      var self  = this;
      var cajas = this.modal.querySelectorAll('[data-register="code-boxes"] input');
      if (!cajas.length) return;

      this.codigo = window.BexMybUi.crearComponenteCodigo({
        cajas: cajas,
        tipo: 'numerico',
        alCambiar: function (delUsuario) {
          if (delUsuario) self.limpiarError('code-error');
          self.refrescarBotonCodigo();
        }
      });

      this.initEnvioCodigo();
      this.initReenvio();
      this.initEdicionCorreo();
      this.initVolver();
      this.initVueltaAlLogin();
      this.initExplorar();
      this.initReinicioAlCerrar();

      // _switchTab() muestra `register` pero no sabe en qué sub-sección estaba
      // el usuario. Al pulsar la pestaña se vuelve siempre al formulario.
      var tab = this.modal.querySelector('.mybarcelo-modal__tab[data-tab="register"]');
      if (tab) {
        tab.addEventListener('click', function () { self.goTo('register'); });
      }
    },

    refrescarBotonCodigo: function () {
      var boton = this.modal.querySelector('[data-register="code-submit"]');
      if (!boton) return;
      boton.disabled = !(this.codigo && this.codigo.completo());
    },

    /**
     * El authorize va en x-www-form-urlencoded, como el del login: el proxy PHP
     * es el mismo handler y lee los parámetros de la misma forma.
     */
    postAuthorize: function (datos) {
      var params = new URLSearchParams(datos);

      return fetch(CONFIG.restBase + '/mybarcelo/registration/authorize', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString()
      }).then(function (resp) {
        return resp.json();
      });
    },

    /**
     * Canjea el código por un authorization code y arranca la sesión.
     *
     * A diferencia de recuperar contraseña, aquí SÍ acabamos con el usuario
     * dentro: el authorize devuelve un `code` canjeable por tokens.
     */
    initEnvioCodigo: function () {
      var self = this;
      var form = this.modal.querySelector('[data-register="code-form"]');
      if (!form) return;

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var boton = form.querySelector('[data-register="code-submit"]');

        if (!self.codigo.completo()) return;

        self.limpiarError('code-error');
        self.bloquear(boton, true);
        self.mostrarCarga(true);

        // El PKCE lo genera el mismo helper que usa el login: el code_verifier
        // tiene que llegar intacto al canje de tokens.
        var auth = window.MyBarceloAuth;

        auth._generatePKCE().then(function (pkce) {
          return self.postAuthorize({
            identifier: self.estado.identifier,
            otp: self.codigo.leer(),
            response_type: 'code',
            client_id: CONFIG.clientId,
            redirect_uri: CONFIG.redirectUri,
            code_challenge: pkce.code_challenge,
            code_challenge_method: 'S256',
            scope: 'refresh_token openid api'
          }).then(function (data) { return { data: data, pkce: pkce }; });
        }).then(function (resultado) {
          var data = resultado.data;

          // Se comprueba `status`, NO `code`: cuando el proxy devuelve un error
          // de WordPress, `code` es el código de error ("mybarcelo_loyalty_error")
          // y mirarlo a secas daba un error por bueno.
          if (data && data.status === 'success' && data.code) {
            return self.arrancarSesion(data.code, resultado.pkce.code_verifier);
          }

          self.bloquear(boton, false);
          self.mostrarCarga(false);

          // El correo ya registrado solo se descubre aquí con el endpoint
          // estándar: no lo dice en el INITIALIZE.
          if (data && data.error_code === 'user_exists') {
            self.pintarCorreoExistente();
            self.goTo('register-exists');
            return;
          }

          // El OTP es de UN SOLO USO: un código equivocado obliga a pedir otro,
          // no vale reintentar con el mismo identifier.
          //
          // `invalid_grant` es lo que devuelve CIAM cuando el par identifier/OTP
          // no cuadra, incluido el caso de un código ya gastado por un intento
          // anterior (comprobado contra PRE el 12-08-2026).
          if (data && (data.error_code === 'invalid_otp' ||
                       data.error_code === 'invalid_otp_format' ||
                       data.error_code === 'invalid_grant')) {
            self.mostrarError('code-error', t('wrongCode', 'That code is not correct. Request a new code and try again.'));
            self.codigo.limpiar();
            return;
          }

          // CIAM tardó más que el cliente HTTP (15 s). No sabemos si llegó a
          // consumir el código, así que se empuja a pedir uno nuevo.
          if (data && data.error_code === 'network_error') {
            self.mostrarError('code-error', t('timeout', 'The service is taking too long to respond. Request a new code and try again.'));
            self.codigo.limpiar();
            return;
          }

          self.mostrarError('code-error', t('registerFailed', 'We could not complete your registration. Request a new code and try again.'));
          self.codigo.limpiar();

        }).catch(function () {
          self.bloquear(boton, false);
          self.mostrarCarga(false);
          self.mostrarError('code-error', t('registerFailed', 'We could not complete your registration. Request a new code and try again.'));
        });
      });
    },

    /**
     * Canjea el code por tokens y deja la sesión abierta, reutilizando la cola
     * token → userinfo → loyalty de mybarcelo-auth.js (_finishLogin), que es la
     * misma que usan el login por correo y el social.
     *
     * Si el canje falla se enseña el éxito igualmente: la cuenta YA está creada
     * en CIAM, y decir lo contrario sería mentir. El usuario entrará a mano.
     */
    arrancarSesion: function (code, verifier) {
      var self = this;
      var auth = window.MyBarceloAuth;

      function terminar() {
        self.mostrarCarga(false);
        self.goTo('register-done');
      }

      if (!auth || typeof auth._finishLogin !== 'function') {
        terminar();
        return Promise.resolve();
      }

      return auth._finishLogin(code, verifier).then(function (user) {
        // _finishLogin guarda tokens y usuario, pero NO pinta nada: en el login
        // esa parte la hace el modal al resolverse. Sin esto la sesión queda
        // establecida y la cabecera sigue diciendo "my Barceló".
        var modal = window.MyBarceloModal;
        if (user && modal && typeof modal._setLoggedState === 'function') {
          modal._setLoggedState(user);
        }
        terminar();
      }).catch(terminar);
    },

    mostrarCarga: function (activo) {
      var overlay = this.modal.querySelector('.mybarcelo-modal__loading');
      if (overlay) overlay.classList.toggle('d-none', !activo);
    },

    // --- Reenvío del código ---

    /**
     * 60 segundos entre reenvíos, con cuenta atrás visible. Sin esto, el botón
     * es una forma cómoda de mandar correos en bucle.
     */
    arrancarCooldown: function (segundos) {
      var boton = this.modal.querySelector('[data-register="resend"]');
      if (!boton) return;

      if (this.temporizador) clearInterval(this.temporizador);

      var original = boton.getAttribute('data-label') || boton.textContent.trim();
      boton.setAttribute('data-label', original);

      var quedan = segundos;
      boton.disabled = true;
      boton.textContent = original + ' (' + quedan + ')';

      this.temporizador = setInterval(function () {
        quedan--;
        if (quedan <= 0) {
          clearInterval(this.temporizador);
          boton.disabled = false;
          boton.textContent = original;
          return;
        }
        boton.textContent = original + ' (' + quedan + ')';
      }.bind(this), 1000);
    },

    /**
     * "Solicitar un nuevo código" repite el INITIALIZE entero: el OTP es de un
     * solo uso y cada envío trae un identifier nuevo.
     */
    initReenvio: function () {
      var self  = this;
      var boton = this.modal.querySelector('[data-register="resend"]');
      if (!boton) return;

      boton.addEventListener('click', function () {
        self.limpiarError('code-error');
        self.bloquear(boton, true);

        self.enviarInit('code-error', boton).then(function (ok) {
          if (!ok) return;

          var aviso  = self.modal.querySelector('[data-register="sent-notice"]');
          var titulo = self.modal.querySelector('[data-register="sent-title"]');

          if (titulo) titulo.textContent = t('newCodeSent', 'New code sent');
          if (aviso) aviso.classList.remove('d-none');

          self.codigo.limpiar();
          self.arrancarCooldown(60);
        });
      });
    },

    /**
     * "Editar" vuelve al formulario con todo relleno.
     *
     * A diferencia de recuperar contraseña, donde editar el correo reenvía el
     * código al vuelo, aquí cambiar el correo obliga a rehacer el alta entera:
     * otro correo es otro usuario y otro identifier.
     */
    initEdicionCorreo: function () {
      var self   = this;
      var editar = this.modal.querySelector('[data-register="edit-email"]');
      if (!editar) return;

      editar.addEventListener('click', function () {
        self.goTo('register');

        var email = document.getElementById('mybarcelo-register-email');
        if (email) {
          email.value = self.estado.email;
          email.focus();
        }
      });
    },

    /** La flecha de register-code vuelve al formulario, con los datos puestos. */
    initVolver: function () {
      var self  = this;
      var boton = this.modal.querySelector('[data-register="back"]');
      if (!boton) return;

      boton.addEventListener('click', function () { self.goTo('register'); });
    },

    /** Desde "correo ya registrado" se va al login con el correo puesto. */
    initVueltaAlLogin: function () {
      var self  = this;
      var boton = this.modal.querySelector('[data-register="go-login"]');
      if (!boton) return;

      boton.addEventListener('click', function () {
        var login = document.getElementById('mybarcelo-email');
        if (login) login.value = self.estado.email;

        if (window.MyBarceloModal && window.MyBarceloModal._switchTab) {
          window.MyBarceloModal._switchTab('login');
        } else {
          self.goTo('login');
        }
      });
    },

    /** "Empezar a explorar" cierra el modal y deja al usuario donde estaba. */
    initExplorar: function () {
      var self  = this;
      var boton = this.modal.querySelector('[data-register="explore"]');
      if (!boton) return;

      boton.addEventListener('click', function () {
        var cerrar = self.modal.querySelector('.mybarcelo-modal__close');
        if (cerrar) cerrar.click();
      });
    },

    /**
     * Cerrar el modal descarta el estado. El código llega por correo, así que
     * volver a empezar cuesta poco y no merece persistirlo.
     */
    initReinicioAlCerrar: function () {
      var self = this;

      var cerrar   = this.modal.querySelector('.mybarcelo-modal__close');
      var backdrop = this.modal.querySelector('.mybarcelo-modal__backdrop');

      [cerrar, backdrop].forEach(function (el) {
        if (el) el.addEventListener('click', function () { self.reiniciar(); });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self.reiniciar();
      });
    },

    reiniciar: function () {
      this.estado = {
        email: '', firstName: '', lastName: '', birthdate: '', password: '', identifier: ''
      };

      if (this.temporizador) {
        clearInterval(this.temporizador);
        this.temporizador = null;
      }

      ['email', 'firstname', 'lastname', 'birthdate'].forEach(function (campo) {
        var el = document.getElementById('mybarcelo-register-' + campo);
        if (el) el.value = '';
      });

      ['consent-privacy', 'consent-program'].forEach(function (nombre) {
        var el = this.modal.querySelector('[data-register="' + nombre + '"]');
        if (el) el.checked = false;
      }.bind(this));

      if (this.politica) this.politica.reiniciar();
      if (this.codigo) this.codigo.limpiar();

      this.limpiarError('error');
      this.limpiarError('code-error');

      var aviso = this.modal.querySelector('[data-register="sent-notice"]');
      if (aviso) aviso.classList.add('d-none');

      var resend = this.modal.querySelector('[data-register="resend"]');
      if (resend) {
        resend.disabled = false;
        var etiqueta = resend.getAttribute('data-label');
        if (etiqueta) resend.textContent = etiqueta;
      }

      // Si se cerró desde register-code, las pestañas quedaron ocultas. No se
      // navega aquí: de eso se encarga BexForgotPassword.reiniciar(), que ya
      // escucha el mismo cierre y hace goTo('login').
      var pestanas = this.modal.querySelector('.mybarcelo-modal__tabs');
      if (pestanas) pestanas.classList.remove('d-none');

      this.refrescarBotonAlta();
    },

    // --- Paso 1: el formulario ---

    initFormulario: function () {
      var self = this;
      var form = this.modal.querySelector('[data-register="form"]');
      if (!form) return;

      // Cualquier cambio recalcula si el botón puede activarse.
      form.addEventListener('input', function () { self.refrescarBotonAlta(); });
      form.addEventListener('change', function () { self.refrescarBotonAlta(); });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        self.enviarAlta();
      });

      this.refrescarBotonAlta();
    },

    leerFormulario: function () {
      return {
        email: (document.getElementById('mybarcelo-register-email').value || '').trim(),
        firstName: (document.getElementById('mybarcelo-register-firstname').value || '').trim(),
        lastName: (document.getElementById('mybarcelo-register-lastname').value || '').trim(),
        birthdate: (document.getElementById('mybarcelo-register-birthdate').value || '').trim(),
        password: document.getElementById('mybarcelo-register-password').value || ''
      };
    },

    esCorreoValido: function (email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },

    /**
     * La fecha existe y no es futura. Sin mínimo de edad: si CIAM lo exige,
     * devolverá su error y lo mostramos.
     */
    esFechaValida: function (iso) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return false;

      var partes = iso.split('-');
      var d = new Date(iso + 'T00:00:00');

      if (d.getFullYear() !== parseInt(partes[0], 10)) return false;
      if (d.getMonth() + 1 !== parseInt(partes[1], 10)) return false;
      if (d.getDate() !== parseInt(partes[2], 10)) return false;

      var hoy = new Date();
      hoy.setHours(0, 0, 0, 0);

      return d <= hoy;
    },

    consentimientosMarcados: function () {
      var privacidad = this.modal.querySelector('[data-register="consent-privacy"]');
      var programa   = this.modal.querySelector('[data-register="consent-program"]');
      return !!(privacidad && privacidad.checked && programa && programa.checked);
    },

    /** El botón solo se activa con todo relleno, la fecha válida y los dos vistos. */
    refrescarBotonAlta: function () {
      var boton = this.modal.querySelector('[data-register="submit"]');
      if (!boton) return;

      var datos = this.leerFormulario();

      boton.disabled = !(
        this.esCorreoValido(datos.email) &&
        datos.firstName !== '' &&
        datos.lastName !== '' &&
        this.esFechaValida(datos.birthdate) &&
        this.politica.ok() &&
        this.consentimientosMarcados()
      );
    },

    enviarAlta: function () {
      var self  = this;
      var datos = this.leerFormulario();
      var boton = this.modal.querySelector('[data-register="submit"]');

      if (!this.esFechaValida(datos.birthdate)) {
        this.mostrarError('error', t('invalidBirthdate', 'Enter a valid date of birth.'));
        return;
      }

      this.estado.email     = datos.email;
      this.estado.firstName = datos.firstName;
      this.estado.lastName  = datos.lastName;
      this.estado.birthdate = datos.birthdate;
      this.estado.password  = datos.password;

      this.limpiarError('error');
      this.bloquear(boton, true);

      this.enviarInit('error', boton).then(function (ok) {
        if (!ok) return;

        self.pintarCorreoActual();
        if (self.codigo) self.codigo.limpiar();
        self.goTo('register-code');
        self.arrancarCooldown(60);
      });
    },

    /**
     * INITIALIZE. Se usa desde el envío del formulario y desde "Solicitar un
     * nuevo código", porque en el registro las dos cosas son la misma llamada.
     *
     * Resuelve a true/false para que quien llama decida qué hacer después.
     */
    enviarInit: function (campoError, boton) {
      var self = this;

      return this.getRecaptchaToken('registration')
        .then(function (token) {
          return self.post('init', {
            email: self.estado.email,
            firstName: self.estado.firstName,
            lastName: self.estado.lastName,
            birthdayDate: self.estado.birthdate,
            password: self.estado.password,
            recaptcha: token
          });
        })
        .then(function (data) {
          self.bloquear(boton, false);

          if (data.status === 'success' && data.identifier) {
            self.estado.identifier = data.identifier;
            return true;
          }

          // El correo ya registrado tiene pantalla propia.
          if (data.error_code === 'user_exists') {
            self.pintarCorreoExistente();
            self.goTo('register-exists');
            return false;
          }

          if (data.error_code === 'invalid_email') {
            self.mostrarError(campoError, t('invalidEmail', 'Enter a valid email address.'));
            return false;
          }

          if (data.error_code === 'invalid_birthdate') {
            self.mostrarError(campoError, t('invalidBirthdate', 'Enter a valid date of birth.'));
            return false;
          }

          if (data.error_code === 'invalid_password') {
            self.mostrarError(campoError, t('weakPassword', 'That password does not meet the requirements.'));
            return false;
          }

          self.mostrarError(campoError, t('genericError', 'We could not process your request. Please try again in a few minutes.'));
          return false;
        })
        .catch(function () {
          self.bloquear(boton, false);
          self.mostrarError(campoError, t('genericError', 'We could not process your request. Please try again in a few minutes.'));
          return false;
        });
    },

    pintarCorreoActual: function () {
      var el = this.modal.querySelector('[data-register="current-email"]');
      if (el) el.textContent = this.estado.email;
    },

    pintarCorreoExistente: function () {
      var el = this.modal.querySelector('[data-register="existing-email"]');
      if (el) el.textContent = this.estado.email;
    },

    mostrarError: function (nombre, mensaje) {
      var el = this.modal.querySelector('[data-register="' + nombre + '"]');
      if (!el) return;
      el.textContent = mensaje;
      el.classList.remove('d-none');
    },

    limpiarError: function (nombre) {
      var el = this.modal.querySelector('[data-register="' + nombre + '"]');
      if (!el) return;
      el.textContent = '';
      el.classList.add('d-none');
    },

    bloquear: function (boton, activo) {
      if (!boton) return;
      boton.disabled = activo;
      boton.classList.toggle('is-loading', activo);
    }
  };

  window.BexRegister = BexRegister;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { BexRegister.init(); });
  } else {
    BexRegister.init();
  }
})();
